<template>
  <div class="component-users">
    <div class="users-list">
      <el-input placeholder="查询姓名,手机号" type="text" v-model="key" @keyup.enter.native="fetchUser">
        <el-button slot="append" icon="el-icon-search" @click="fetchUser"></el-button>
      </el-input>
      <div v-for="user in users" :key="user.ID" class="user-info">
        <div class="user-name">
          <span>{{user.name}}</span>
          <span style="margin-left:20px;">{{user.phone}}</span>
        </div>
        <div class="btn-box">
          <el-button v-if="!user.has_user" type="warning" size="mini" @click="addUser(user.ID)">选TA</el-button>
          <el-button v-else type="info" size="mini" :disabled="true">已在群里</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    show_user: Boolean,
    group_users: Array,
    room_id: [Number, String]
  },
  data() {
    return {
      users: [],
      page: {},
      key: ""
    };
  },
  mounted() {},
  methods: {
    fetchUser() {
      this.$api.getUsers({ key: this.key, limit: 150 }).then(res => {
        this.users = res.result.users.map(i => {
          let eu = this.group_users.filter(e => e.ID == i.ID);
          i["has_user"] = false;
          if (eu.length > 0) {
            i["has_user"] = true;
          }
          return i;
        });
        this.page = res.result.page;
      });
    },
    addUser(uid) {
      this.$api.addUserToRoom({ id: this.room_id, ids: uid }).then(res => {
        if (res.code == 200) {
          this.$message.success({ message: res.msg });
          this.$emit("complete_event", true);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.user-info {
  border-bottom: 1px solid #ccc;
  margin: 12px 0;
  padding: 6px 12px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
